"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormattedDisplay = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("@bimser/components");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const Plugins = tslib_1.__importStar(require("../plugins"));
function getFormattedDisplay(valueType, value) {
    switch (valueType) {
        case 1 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.String */:
        case 3 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Integer */:
            return value;
        case 2 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Boolean */:
            return typeof value === 'boolean' ? value.toString() : 'false';
        case 6 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.DateTime */:
        case 16 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Date */:
        case 12 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.DateTimeOffset */:
            return (0, dayjs_1.default)(value).isValid() ? (0, jsx_runtime_1.jsx)(components_1.FormattedDate, { value: value }) : '';
        case 8 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Time */:
            return value;
        case 15 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Decimal */:
        case 4 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.Float */:
            return (0, jsx_runtime_1.jsx)(components_1.BCFormattedNumber, { value: value });
    }
}
exports.getFormattedDisplay = getFormattedDisplay;
//# sourceMappingURL=getFormattedDisplay.js.map